export const APP_VERSION = '0.12.0';